// BCP 47 language tag codes
export enum LocaleCode {
  ar_SA = 'ar-SA',
  en_US = 'en-US',
  fr_FR = 'fr-FR',
  de_DE = 'de-DE',
  el_GR = 'el-GR',
  he_IL = 'he-IL',
  id_ID = 'id-ID',
  it_IT = 'it-IT',
  ja_JP = 'ja-JP',
  ko_KR = 'ko-KR',
  pl_PL = 'pl-PL',
  pt_BR = 'pt-BR',
  ru_RU = 'ru-RU',
  zh_CN = 'zh-CN',
  es_ES = 'es-ES',
  es_419 = 'es-419',
  th_TH = 'th-TH',
  zh_TW = 'zh-TW',
  tr_TR = 'tr-TR',
  vi_VN = 'vi-VN',
}

export const DEFAULT_LOCALE = LocaleCode.en_US;

export enum TextDirection {
  RTL = 'rtl',
  LTR = 'ltr',
}

export type Locale = {
  id: LocaleCode;
  description: string;
  label: string;
  dir: TextDirection;
};

/**
 * All available locales.
 * This also represents the list order represented in the UI.
 */
export const LOCALES: { [key: string]: Locale } = {
  // RTL locales, like ar, are not yet supported. https://sim.amazon.com/issues/Vibe-485
  [LocaleCode.ar_SA]: {
    id: LocaleCode.ar_SA,
    description: 'Arabic',
    label: 'العربية',
    dir: TextDirection.RTL,
  },
  [LocaleCode.en_US]: {
    id: LocaleCode.en_US,
    description: 'English',
    label: 'English',
    dir: TextDirection.LTR,
  },
  [LocaleCode.fr_FR]: {
    id: LocaleCode.fr_FR,
    description: 'French',
    label: 'Français',
    dir: TextDirection.LTR,
  },
  [LocaleCode.de_DE]: {
    id: LocaleCode.de_DE,
    description: 'German',
    label: 'Deutsch',
    dir: TextDirection.LTR,
  },
  [LocaleCode.el_GR]: {
    id: LocaleCode.el_GR,
    description: 'Greek',
    label: 'Ελληνικά',
    dir: TextDirection.LTR,
  },
  // RTL locales, like he, are not yet supported. https://sim.amazon.com/issues/Vibe-485
  [LocaleCode.he_IL]: {
    id: LocaleCode.he_IL,
    description: 'Hebrew',
    label: 'עברית',
    dir: TextDirection.RTL,
  },
  [LocaleCode.id_ID]: {
    id: LocaleCode.id_ID,
    description: 'Indonesian',
    label: 'Bahasa Indonesia',
    dir: TextDirection.LTR,
  },
  [LocaleCode.it_IT]: {
    id: LocaleCode.it_IT,
    description: 'Italian',
    label: 'Italiano',
    dir: TextDirection.LTR,
  },
  [LocaleCode.ja_JP]: {
    id: LocaleCode.ja_JP,
    description: 'Japanese',
    label: '日本語',
    dir: TextDirection.LTR,
  },
  [LocaleCode.ko_KR]: {
    id: LocaleCode.ko_KR,
    description: 'Korean',
    label: '한국어',
    dir: TextDirection.LTR,
  },
  [LocaleCode.pl_PL]: {
    id: LocaleCode.pl_PL,
    description: 'Polish',
    label: 'Polski',
    dir: TextDirection.LTR,
  },
  [LocaleCode.pt_BR]: {
    id: LocaleCode.pt_BR,
    description: 'Portuguese (Brazil)',
    label: 'Português (Brasil)',
    dir: TextDirection.LTR,
  },
  [LocaleCode.ru_RU]: {
    id: LocaleCode.ru_RU,
    description: 'Russian',
    label: 'Ρусский',
    dir: TextDirection.LTR,
  },
  [LocaleCode.zh_CN]: {
    id: LocaleCode.zh_CN,
    description: 'Simplified Chinese',
    label: '中文（简体）',
    dir: TextDirection.LTR,
  },
  [LocaleCode.es_ES]: {
    id: LocaleCode.es_ES,
    description: 'Spanish',
    label: 'Español',
    dir: TextDirection.LTR,
  },
  [LocaleCode.es_419]: {
    id: LocaleCode.es_419,
    description: 'Spanish, Latin America',
    label: 'Español (Latinoamérica)',
    dir: TextDirection.LTR,
  },
  [LocaleCode.th_TH]: {
    id: LocaleCode.th_TH,
    description: 'Thai',
    label: 'ไทย',
    dir: TextDirection.LTR,
  },
  [LocaleCode.zh_TW]: {
    id: LocaleCode.zh_TW,
    description: 'Traditional Chinese',
    label: '中文（繁體）',
    dir: TextDirection.LTR,
  },
  [LocaleCode.tr_TR]: {
    id: LocaleCode.tr_TR,
    description: 'Turkish',
    label: 'Türkçe',
    dir: TextDirection.LTR,
  },
  [LocaleCode.vi_VN]: {
    id: LocaleCode.vi_VN,
    description: 'Vietnames',
    label: 'Tiếng Việt',
    dir: TextDirection.LTR,
  },
};
